import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import apiClient from '../api/api';
import { FaUsers } from 'react-icons/fa';

function BrokerRosterPage() {
    const { user } = useAuth();
    const [roster, setRoster] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchRoster = useCallback(async () => {
        if (!user?.profileId) return;
        try {
            const response = await apiClient.get('/broker/roster');
            setRoster(response.data || []);
        } catch (err) {
            console.error("Failed to fetch roster:", err);
            setError('Could not load your worker roster.');
        }
    }, [user]);

    useEffect(() => {
        setLoading(true);
        fetchRoster().finally(() => setLoading(false));
    }, [fetchRoster]);

    return (
        <div className="space-y-6">
            <h1 className="text-3xl font-bold text-gray-800 flex items-center">
                <FaUsers className="mr-3 text-blue-500" /> My Worker Roster
            </h1>

            {error && <div className="bg-red-100 text-red-700 p-4 rounded-lg">{error}</div>}

            <div className="bg-white p-6 rounded-2xl shadow-lg">
                {loading ? <p>Loading roster...</p> : roster.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {roster.map(member => (
                            <div key={member.id} className="p-4 border rounded-xl bg-gray-50 hover:shadow-md transition-shadow">
                                <div className="flex justify-between items-start mb-2">
                                    <div>
                                        <p className="font-bold text-gray-800 text-lg">{member.worker.name}</p>
                                        <p className="text-sm text-gray-500">{member.worker.contact_No}</p>
                                    </div>
                                    <span className={`px-2 py-1 text-xs rounded-full ${member.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                                        {member.status}
                                    </span>
                                </div>
                                <button className="text-blue-500 hover:underline text-sm mt-2">View Profile</button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-center text-gray-500 p-8">Your roster is empty. Go to "Find Workers" to add people.</p>
                )}
            </div>
        </div>
    );
}

export default BrokerRosterPage;
